module.exports = __webpack_public_path__ + "media/assets/services_manager/circled-plus-fada180374042430a72619c5c6deb0c88aade288920ccf961490bb69619de4a8.svg";